export class DiaryFormElementMessageTranslation {
  diaryFormElementMessageId: string;
  culture: string;
  text: string;

  constructor(init?: Partial<DiaryFormElementMessageTranslation>) {
    Object.assign(this, init);
  }
}
